import { Pipe, PipeTransform } from '@angular/core';
import { GameAnswerObject } from '../data-models/game-answer-object';
import { Language, LanguageService } from '../services/language-service.service';
import { Difficulty } from '../services/question.service';

/*
 * Translate game content based on type.
 * Takes an isUiText argument that true.
 * Usage:
 *   value | translate:isUiText
 * Example:
 *   {{ content | translate:false }}
*/

@Pipe({
  name: 'translate'
})
export class TranslatePipe implements PipeTransform {

  constructor(private languageService: LanguageService) {}


  transform(value: any, isUiText: boolean = true, language: Language = this.languageService.uiLanguage, itemName: boolean = false): string {

    if (isUiText) {
      if (this.languageService.uiLanguage) {
        return this.languageService.UiTexts[value][language];
      }
      else {
        return this.languageService.UiTexts[value].fi;
      }
    }
    else if (itemName) {
      return value.content[Difficulty.Easy][this.languageService.learnLanguage];
    }
    else {
      return value.content[this.languageService.learnDifficulty][this.languageService.learnLanguage];
    }


  }

}
